const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.employees.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindCompanyLinkCategoriesQueryOptions, getFindCompanySitesQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/companies/$id/employees')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    const {
      id: companyId
    } = params;
    queryClient.ensureQueryData(getFindCompanyLinkCategoriesQueryOptions());
    queryClient.ensureQueryData(getFindCompanySitesQueryOptions(companyId));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});